/** @file Follows ghostStore: builds the ghost over the current page table, or drops it (W3-33). */
import { ghostStore } from '../../stores/ghostStore';
import type { RuntimeState } from './runtimeState';
import { ghostScene } from './scene/ghostScene';

/** Called when ghostStore holds another ghost and when a new rig gets its page table; marks the frame dirty. */
export function syncGhost(s: RuntimeState): void {
  const { ghost } = ghostStore.getState();
  s.ghost = s.pages === null ? null : ghostScene(ghost, s.pages);
  s.dirty = true;
}
